module.exports = __webpack_public_path__ + "img/section4Logo8.6f0e2315.svg";